export default "__VITE_ASSET__B4zcAGpz__"